export default {
  students: [],
  subjects: [],
  apiCallsInProgress: 0,
}
